import React, { useState, useEffect } from 'react'
import { connect } from 'react-redux'
import { Redirect, useLocation } from 'react-router-dom'
import { loadStripe } from '@stripe/stripe-js'
import { Elements } from '@stripe/react-stripe-js'
import { t, getCurrentLanguage } from 'translation'

import SubscriptionDoctorStepOne from 'components/Subscription/SubscriptionDoctorStepOne'
import SubscriptionDoctorStepTwo from 'components/Subscription/SubscriptionDoctorStepTwo'
import SubscriptionPatientStepOne from 'components/Subscription/SubscriptionPatientStepOne'
import SubscriptionPatientStepTwo from 'components/Subscription/SubscriptionPatientStepTwo'
import Spinner from 'components/ui/Spinner/Spinner'

import { resetAuthError, authFail, authRefreshToken } from 'store/actions'

import { contactApi } from 'api'

import BgLoginImg from 'assets/woman.jpg'
import LogoLoginImg from 'assets/logo_tr.png'
import SubscriptionPatientStepZero from 'components/Subscription/SubscriptionPatientStepZero'

const subscriptionSteps = {
  one: SubscriptionDoctorStepOne,
  two: SubscriptionDoctorStepTwo,
  three: SubscriptionPatientStepOne,
  four: SubscriptionPatientStepTwo,
  zeroPatient: SubscriptionPatientStepZero,
}

const ENV = process.env.NODE_ENV

const stripePublicKey =
  ENV === 'production'
    ? process.env.STRIPE_PUBLIC_KEY_PRODUCTION
    : ENV === 'dev-remote'
    ? process.env.STRIPE_PUBLIC_KEY_DEV_REMOTE
    : process.env.STRIPE_PUBLIC_KEY_DEVELOPMENT

const SubscriptionPage = (props) => {
  const [stripePromise, setStripePromise] = useState(null)
  const [scaleClassIsSet, setScaleClassIsSet] = useState(false)
  const [subscriptionStep, setSubscriptionStep] = useState('zero')
  const [price, setPrice] = useState('')
  const [currency, setCurrency] = useState('')
  const [customer, setCustomer] = useState(false)

  useEffect(() => {
    setStripePromise(loadStripe(stripePublicKey))
  }, [])

  useEffect(() => {
    const handle = async () => {
      if (!props.isPro) {
        if (subscriptionStep === 'zero') setSubscriptionStep('three')

        const { result, error } = await contactApi.getTrialTicket()

        if (error) {
          console.log('Error:', error)
        }

        if (
          !result.ticketExist &&
          !props?.otherInfo?.hasOwnProperty('subscriptionId') &&
          props.licenses?.freeDays > 0
        )
          setSubscriptionStep('zeroPatient')

        setPrice(`${props.attributes?.licenses?.patientSubscriptionPrice}0` || '9.90')
        setCurrency(props.attributes?.licenses?.currency || 'EUR')
      }

      if (props.isDoctor) {
        if (subscriptionStep === 'zero') setSubscriptionStep('one')

        setPrice(t('subscription.PRICE'))
        setCurrency(t('subscription.CURRENCY'))
      }

      if (props.otherInfo?.hasOwnProperty('customerId')) setCustomer(true)
    }

    handle()
  }, [])

  useEffect(() => {
    document.documentElement.classList.add('no_scale_mod')
    setScaleClassIsSet(true)
    return
  }, [])

  const SubscriptionStep = subscriptionSteps[subscriptionStep]

  if (props.isPro && !props.isDoctor) return <Redirect to="/" />
  if (props.subscribed) return <Redirect to="/" />

  return (
    <>
      {window?.cordova && props.isDoctor ? <Redirect to={`/access`} /> : null}
      {props.isDoctor && props.subscribed ? <Redirect to={`/`} /> : null}
      <section className="section login_mod">
        {scaleClassIsSet && (
          <>
            <div className="section_bg login_mod">
              <img className="section_bg_img" src={BgLoginImg} alt="section background" />
            </div>
            {subscriptionSteps && stripePromise ? (
              <div className="section_in login_mod">
                <div className="logo login_mod">
                  <img className="logo_img" src={LogoLoginImg} alt="logo" />
                </div>
                <Elements
                  stripe={stripePromise}
                  options={{
                    fonts: [
                      {
                        family: 'Bariol',
                        // TODO: Temporary solution, figure out why local import 'url(/fonts/Bariol-Regular.woff2)' 'url(./fonts/Bariol-Regular.woff2)' or 'url(fonts/Bariol-Regular.woff2)' does not work
                        src: 'url(https://music-care-storage-dev.s3.amazonaws.com/assets/Bariol-Regular.woff2)',
                        weight: '400',
                      },
                    ],
                  }}
                >
                  <SubscriptionStep
                    setSubscriptionStep={(newSubscriptionStep) => {
                      Object.keys(subscriptionStep).includes(newSubscriptionStep)
                      setSubscriptionStep(newSubscriptionStep)
                    }}
                    price={price}
                    setPrice={setPrice}
                    currency={currency}
                    setCurrency={setCurrency}
                    freeDays={0}
                    authRefreshToken={props.authRefreshToken}
                    authFail={props.authFail}
                    resetAuthError={props.resetAuthError}
                  />
                </Elements>
              </div>
            ) : (
              <Spinner />
            )}
          </>
        )}
      </section>
    </>
  )
}

const mapStateToProps = ({ auth: { error, attributes, isDoctor, isPro } }) => ({
  authError: error,
  attributes,
  isDoctor,
  isPro,
  licenses: attributes?.licenses,
  otherInfo: attributes?.otherInfo,
  subscribed: JSON.parse(attributes?.subscribed || false),
})

const willMapDispatchToProps = {
  authFail,
  resetAuthError,
  authRefreshToken,
}

export default connect(mapStateToProps, willMapDispatchToProps)(SubscriptionPage)
